import { render } from "./OutrasPublicacoesView.vue?vue&type=template&id=43a664dc&scoped=true"
import script from "./OutrasPublicacoesView.vue?vue&type=script&lang=js"
export * from "./OutrasPublicacoesView.vue?vue&type=script&lang=js"

import "./OutrasPublicacoesView.vue?vue&type=style&index=0&id=43a664dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43a664dc"]])

export default __exports__